import { Box, VStack, useColorModeValue, useColorMode } from '@chakra-ui/react'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Disclaimer } from '../../types/chatTypes'

interface DisclaimerBoxProps {
  disclaimers?: Disclaimer[]
}

const getDisclaimerColor = (type: Disclaimer['type'], colorMode: 'light' | 'dark'): string => {
  switch (type) {
    case 'GENERAL_DISEASE':
      return colorMode === 'dark' ? '#7a7979' : '#e6e6e6'
    case 'ZOONOSIS_DISEASE':
      return colorMode === 'dark' ? '#ba1414' : '#ffe0e0'
    case 'FUNCTIONAL_SUPPORT':
      return colorMode === 'dark' ? '#7a7979' : '#e6e6e6'
    default:
      return colorMode === 'dark' ? '#e6e6e6' : '#e6e6e6'
  }
}

const DisclaimerBox: React.FC<DisclaimerBoxProps> = ({ disclaimers }) => {
  const { colorMode } = useColorMode()
  const borderColor = useColorModeValue('gray.200', 'gray.600')

  if (!disclaimers || disclaimers.length === 0) {
    return null
  }

  const triggeredDisclaimers = disclaimers.filter(d => d.triggered)

  if (triggeredDisclaimers.length === 0) {
    return null
  }

  return (
    <VStack spacing={2} width='85%' align='flex-start' mt={2}>
      {triggeredDisclaimers.map(disclaimer => (
        <Box
          key={disclaimer.type}
          px={4}
          py={3}
          borderRadius='6px'
          backgroundColor={getDisclaimerColor(disclaimer.type, colorMode)}
          border='1px solid'
          borderColor={borderColor}
          fontSize='sm'
          lineHeight='1.5'
          width='fit-content'
          maxWidth='100%'
        >
          <ReactMarkdown>{disclaimer.disclaimer_message}</ReactMarkdown>
        </Box>
      ))}
    </VStack>
  )
}

export default DisclaimerBox
